/*
#*===================================================================
#*
#* Licensed Materials - Property of GameTimeFootage Inc.
#*
#* Copyright NextPro 2018. All Rights Reserved.
#*
#*===================================================================
*/
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromGetHeaderNotifications from '../actions/header-notifications.action';

export interface GetHeaderNotificationsState extends EntityState<any> {
  errorMessage: string;
  success: boolean;
  loading: boolean;
}

export const headerNotificationsAdapter: EntityAdapter<any> = createEntityAdapter<any>();

export const defaultHeaderNotifications: GetHeaderNotificationsState = {
  ids: [],
  entities: {},
  errorMessage: null,
  success: false,
  loading: false,
};

export const initialState = headerNotificationsAdapter.getInitialState(defaultHeaderNotifications);

export function reducer(
  state = initialState,
  action: fromGetHeaderNotifications.GetHeaderNotificationsAction
): GetHeaderNotificationsState {
  switch (action.type) {
    case fromGetHeaderNotifications.GET_HEADER_NOTIFICATIONS: {
      return {
        ...state,
        ids: [],
        entities: {},
        errorMessage: null,
        loading: true,
        success: false,
      };
    }

    case fromGetHeaderNotifications.GET_HEADER_NOTIFICATIONS_FAIL: {
      return {
        ...state,
        ids: [],
        entities: {},
        errorMessage: action.payload,
        loading: false,
        success: false,
      };
    }

    case fromGetHeaderNotifications.GET_HEADER_NOTIFICATIONS_SUCCESS: {
      return headerNotificationsAdapter.setAll(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetHeaderNotifications.UPDATE_HEADER_NOTIFICATIONS: {
      return {
        ...state,
        loading: true,
        success: false,
      };
    }

    case fromGetHeaderNotifications.UPDATE_HEADER_NOTIFICATIONS_SUCCESS: {
      return headerNotificationsAdapter.upsertOne(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetHeaderNotifications.DELETE_HEADER_NOTIFICATIONS: {
      return {
        ...state,
        loading: true,
        success: false,
      };
    }

    case fromGetHeaderNotifications.DELETE_HEADER_NOTIFICATIONS_SUCCESS: {
      return headerNotificationsAdapter.removeOne(action.payload, {
        ...state,
        errorMessage: null,
        loading: false,
        success: true,
      });
    }

    case fromGetHeaderNotifications.ADD_HEADER_NOTIFICATIONS: {
      return headerNotificationsAdapter.addOne(action.payload, {
        ...state,
      });
    }
  }

  return state;
}

const getHeaderNotificationsState = createFeatureSelector<GetHeaderNotificationsState>('headerNotifications');

export const getHeaderNotificationsData = createSelector(
  getHeaderNotificationsState,
  headerNotificationsAdapter.getSelectors().selectAll
);

export const getHeaderNotificationsErrorMessage = createSelector(
  getHeaderNotificationsState,
  (state: GetHeaderNotificationsState) => state.errorMessage
);
export const getHeaderNotificationsLoading = createSelector(
  getHeaderNotificationsState,
  (state: GetHeaderNotificationsState) => state.loading
);
export const getHeaderNotificationsSuccess = createSelector(
  getHeaderNotificationsState,
  (state: GetHeaderNotificationsState) => state.success
);
